import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

const SwatchSelector = lazy(() => import('./SwatchSelectorMain'));

const PdpRespSwatchSelectorComponent = props => {
    const {
        currency,
        onClick,
        item,
        user,
        relay,
        transactions,
        selectedSkuId,
        showSwatchDescriptionOnHover,
        showPrice,
    } = props;

    return (
        <Suspense fallback={''}>
            <SwatchSelector
                currency={currency}
                selectedSkuId={selectedSkuId}
                item={item}
                user={user}
                transactions={transactions}
                onClick={onClick}
                relay={relay}
                pageLayout="PDP"
                showSwatchDescriptionOnHover={showSwatchDescriptionOnHover}
                showPrice={showPrice}
            />
        </Suspense>
    );
};

PdpRespSwatchSelectorComponent.propTypes = {
    currency: PropTypes.string,
    relay: PropTypes.object.isRequired,
    onSwatchClick: PropTypes.func,
    selectedSkuId: PropTypes.string,
    onClick: PropTypes.func,
    showSwatchDescriptionOnHover: PropTypes.bool,
    showPrice: PropTypes.bool,

    // relay response data
    user: PropTypes.object,
    item: PropTypes.object.isRequired,
    transactions: PropTypes.object,
};
export const PdpRespSwatchSelector = createFragmentContainer(PdpRespSwatchSelectorComponent, {
    item: graphql`
        fragment PdpRespSwatchSelector_item on Item {
            ...SwatchSelector_item @arguments(shouldFetchBuyerInfo: true)
        }
    `,
    user: graphql`
        fragment PdpRespSwatchSelector_user on User {
            ...SwatchSelector_user
        }
    `,
    transactions: graphql`
        fragment PdpRespSwatchSelector_transactions on TransactionConnection {
            ...SwatchSelector_transactions
        }
    `,
});
